import React from "react";
import { PreferenceFile } from "../../../Model/Preference";

type Props = {
  preferenceFiles: PreferenceFile[];
  selectedCategory: string;
  setSelectedCategory: React.Dispatch<React.SetStateAction<string>>;
};

export default function PreferenceCategory({
  preferenceFiles,
  selectedCategory,
  setSelectedCategory,
}: Props) {
  const onClickCategory = (name: string) => {
    setSelectedCategory(name);
  };

  return (
    <div className="preference-category">
      <div className="category-header">Category</div>
      {preferenceFiles.map((prefFile) => {
        return (
          <div
            key={prefFile.name}
            className={
              prefFile.name === selectedCategory
                ? "category-item selected"
                : "category-item"
            }
            onClick={() => onClickCategory(prefFile.name)}
          >
            <span>{prefFile.displayName}</span>
            <svg
              width="8"
              height="12"
              viewBox="0 0 8 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 0L0.59 1.41L5.17 6L0.59 10.59L2 12L8 6L2 0Z"
                fill="#313131"
              />
              <path
                d="M2 0L0.59 1.41L5.17 6L0.59 10.59L2 12L8 6L2 0Z"
                fill="#313131"
              />
            </svg>
          </div>
        );
      })}
    </div>
  );
}
